import { Component, OnInit, Inject } from '@angular/core';
import { ErrorStateMatcher, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ConfirmComponent } from '../../../shared/dialogs/confirm/confirm.component';
import { ConfigService } from '../../../services/config.service';
import { Config } from '../../../models/config';
import { AuthService } from '../../../services/auth.service';
import { SnackBarIconService } from '../../../shared/snack-bar-icon/snack-bar-icon.service';

//import * as Base64UploadAdapter from '@ckeditor/ckeditor5-upload/src/base64uploadadapter';

import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-config-dialog',
  templateUrl: './config-dialog.component.html',
  styleUrls: ['./config-dialog.component.scss'],
  entryComponents: [
    ConfirmComponent
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' }
  ]
})
export class ConfigDialogComponent implements OnInit {

  public Editor = ClassicEditor;
  public matcher = new FormErrorStateMatcher();
  public entityForm: FormGroup;   // store User Form
  public isEdit: boolean = false; // is insert or update
  public spinner: boolean = false;

  public formats: any[] = []
  public flag_html: boolean = false;
  public flag_plain: boolean = false;


  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private _configService: ConfigService,
    private _authService: AuthService,
    private snackBar: SnackBarIconService,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DIALOG_DATA) public data: Config
  ) {
    this.formats.push({ 'id': 'plain', 'name': 'Plain' })
    this.formats.push({ 'id': 'html', 'name': 'HTML' })
  }


  ngOnInit() {

    this._adapter.setLocale('pt');

    // check is is insert or update
    if (this.data.id != "0") {
      this.isEdit = true;
    }

    this.entityForm = this.createForm()
    this.setFormValues(this.data, this.entityForm)
  }

  insert() {
    if (this.entityForm.valid) {
      this.spinner = true;
      let entity: Config = this.createEntity(this.entityForm.value);

      this._configService.insert(entity)
        .then((result) => {
          this.data.id = result.id
          this.isEdit = true;
          this.entityForm.controls.id.setValue(result.id);
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch((error) => {
          console.log("insert room error: " + error)
          let msgError: string = this._configService.makeMsgError(error.details.code)
          this.snackBar.openSnackBar(msgError, '', 'error');
        })
        .finally(() => {
          this.spinner = false
        });
    }

  }

  update() {
    if (this.entityForm.valid) {

      this.spinner = true;
      let entity: Config = this.createEntity(this.entityForm.value);

      this._configService.update(entity)
        .then(() => {
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch((error) => {
          console.log("room update error: " + JSON.stringify(error))
          let msgError: string = this._configService.makeMsgError(error.details.code)
          this.snackBar.openSnackBar(msgError, '', 'error');
        })
        .finally(() => {
          this.spinner = false
        });
    }
  }

  createEntity(data: any): Config {
    let entity = new Config();
    entity.id = data.id;
    entity.name = data.name;
    entity.format = data.format;
    entity.plain_text = data.plain_text ? data.plain_text : "";
    entity.plain_text_en = data.plain_text_en ? data.plain_text_en : "";
    entity.html_text = data.html_text ? data.html_text : "";
    entity.html_text_en = data.html_text_en ? data.html_text_en : "";
    return entity;
  }

  setFormValues(data, form) {
    form.controls.id.setValue(data.id);
    form.controls.name.setValue(data.name);
    form.controls.format.setValue(data.format);
    form.controls.plain_text.setValue(data.plain_text);
    form.controls.plain_text_en.setValue(data.plain_text_en);
    form.controls.html_text.setValue(data.html_text);
    form.controls.html_text_en.setValue(data.html_text_en);

    if (data) {
      if (data.format == 'plain') {
        this.flag_html = false;
        this.flag_plain = true;
      } else if (data.format == 'html') {
        this.flag_html = true;
        this.flag_plain = false;
      } else {
        this.flag_html = false;
        this.flag_plain = false;
      }
    }

  }

  createForm() {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      name: new FormControl('', [Validators.required]),
      format: new FormControl('', [Validators.required]),
      plain_text: new FormControl(''),
      plain_text_en: new FormControl(''),
      html_text: new FormControl(''),
      html_text_en: new FormControl('')
    });
    return form
  }

  selectFormat(event) {
    if (event == 'plain') {
      this.flag_plain = true;
      this.flag_html = false;
    } else {
      this.flag_plain = false;
      this.flag_html = true;
    }
  }
}
